// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__2mjj_","emptyLabel":"List_emptyLabel__3SfRd","dropzone":"List_dropzone__1toz8","spacer":"List_spacer__25nTZ","addCard":"List_addCard__2LTFt"};